import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "36.518",
  height: "26.124",
  viewBox: "0 0 36.518 26.124"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  id: "Tracé_1770",
  "data-name": "Tracé 1770",
  d: "M2,4.653H34.519V22.719H2Zm-2-2V24.718H17.26v2.059H4.627v2H31.892v-2H19.26V24.718H36.518V2.653Z",
  transform: "translate(0 -2.653)",
  fill: "#fff"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}